
import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import Platform from './pages/Platform'
import Database from './pages/Database'
import DatabaseUpload from './pages/DatabaseUpload'
import InteractiveAnalysis from './pages/InteractiveAnalysis'
import Metodologia from './pages/Metodologia'
import Instituciones from './pages/Instituciones'
import Mapoteca from './pages/Mapoteca'
import Visualizador from './pages/Visualizador'
import ArchivosDescargables from './pages/ArchivosDescargables'
import DatabaseJerarquizacion from './pages/DatabaseJerarquizacion'
import DatosCompletos from './pages/DatosCompletos'
import MicrocuencasVariables from './pages/MicrocuencasVariables'
import DataVisualization from './pages/DataVisualization'
import JerarquizacionCompleta from './pages/JerarquizacionCompleta'
import TablaCompleta from './pages/TablaCompleta'
import ActualizarDatos from './pages/ActualizarDatos'


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/plataforma" element={<Platform />} />
          <Route path="/base-datos" element={<Database />} />
          <Route path="/base-datos-upload" element={<DatabaseUpload />} />
          <Route path="/base-datos-jerarquizacion" element={<DatabaseJerarquizacion />} />
          <Route path="/datos-completos" element={<DatosCompletos />} />
          <Route path="/microcuencas-variables" element={<MicrocuencasVariables />} />
          <Route path="/analisis-interactivo" element={<InteractiveAnalysis />} />
          <Route path="/visualizador" element={<Visualizador />} />
          <Route path="/metodologia" element={<Metodologia />} />
          <Route path="/instituciones" element={<Instituciones />} />
          <Route path="/mapoteca" element={<Mapoteca />} />
          <Route path="/archivos-descargables" element={<ArchivosDescargables />} />
          <Route path="/visualizacion-datos" element={<DataVisualization />} />
          <Route path="/jerarquizacion-completa" element={<JerarquizacionCompleta />} />
          <Route path="/tabla-completa" element={<TablaCompleta />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App
